__turbopack_context__.v({
  "chip": "dice-module__O2r8xW__chip",
  "chipFacet": "dice-module__O2r8xW__chipFacet",
  "chipValue": "dice-module__O2r8xW__chipValue",
  "dicePlugin": "dice-module__O2r8xW__dicePlugin",
  "die-d10": "dice-module__O2r8xW__die-d10",
  "die-d100": "dice-module__O2r8xW__die-d100",
  "die-d12": "dice-module__O2r8xW__die-d12",
  "die-d20": "dice-module__O2r8xW__die-d20",
  "die-d3": "dice-module__O2r8xW__die-d3",
  "die-d4": "dice-module__O2r8xW__die-d4",
  "die-d6": "dice-module__O2r8xW__die-d6",
  "die-d8": "dice-module__O2r8xW__die-d8",
  "dieWrapper": "dice-module__O2r8xW__dieWrapper",
  "droppedDie": "dice-module__O2r8xW__droppedDie",
  "face": "dice-module__O2r8xW__face",
  "faceLabel": "dice-module__O2r8xW__faceLabel",
  "groupNote": "dice-module__O2r8xW__groupNote",
  "groupSign": "dice-module__O2r8xW__groupSign",
  "result": "dice-module__O2r8xW__result",
  "resultGroup": "dice-module__O2r8xW__resultGroup",
  "resultGroups": "dice-module__O2r8xW__resultGroups",
  "solid": "dice-module__O2r8xW__solid",
  "throwLayer": "dice-module__O2r8xW__throwLayer",
  "throwLayerDone": "dice-module__O2r8xW__throwLayerDone",
  "total": "dice-module__O2r8xW__total",
  "underline": "dice-module__O2r8xW__underline",
});
